import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  mutation SetPassword($token: String!, $email: String!, $password: String!) {\n    setPassword(token: $token, email: $email, password: $password) {\n      errors {\n        field\n        message\n      }\n      token\n      user {\n        ...User\n      }\n      accountErrors {\n        field\n        message\n        code\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  mutation AccountUpdate($input: AccountInput!) {\n    accountUpdate(input: $input) {\n      errors {\n        field\n        message\n      }\n      user {\n        ...User\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation PasswordChange($newPassword: String!, $oldPassword: String!) {\n    passwordChange(newPassword: $newPassword, oldPassword: $oldPassword) {\n      errors {\n        field\n        message\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
import { userFragment } from "../fragments/auth";
export var changeUserPassword = gql(_templateObject());
export var accountUpdate = gql(_templateObject2(), userFragment);
export var setPassword = gql(_templateObject3(), userFragment);